// Dark web: a brand accent-gradient circle (per the dark design handoff) so the avatar reads as an
// elevated brand element instead of blending into the dark header (background.default == app bg).
const getAvatarBackground = (palette, isNativeMobile) => {
  if (isNativeMobile) {
    return palette.primary.main;
  }

  if (palette.mode === 'dark') {
    return `linear-gradient(135deg, ${palette.primary.main}, ${palette.primary.light})`;
  }

  return palette.background.default;
};

export const getBoxStyles = ({ size, withBorder, isNativeMobile }) => ({
  width: `${size}px`,
  height: `${size}px`,
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: ({ palette }) => getAvatarBackground(palette, isNativeMobile),
  border: ({ palette }) =>
    withBorder && !isNativeMobile && palette.mode !== 'dark'
      ? `1px solid ${palette.border.default}`
      : 'none',
});

export const avatarStyles = {
  width: '100%',
  height: '100%',
};
